import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { formatPhoneNumber } from '../../../../../../../services/geo/e-164';
import { NS_COMMON, NSPP_PATIENT } from '../../../../../../../services/i18n/namespaces';
import { usePatientProfile } from '../../PatientProfileContext';

export default function PatientDetailsGuardianInformation() {
  const { t } = useTranslation();
  const { patientInfo } = usePatientProfile();
  const { guardian } = patientInfo || {};
  const { firstName, lastName, phoneCode, phone, email, dob } = guardian || {};

  return (
    <div className="patient-profile-information-content-section">
      <div className="patient-profile-information-header">
        <div className="patient-profile-information-header-title">
          {t('profile.guardianInformation', { ns: NSPP_PATIENT })}
        </div>
      </div>

      <div className="patient-profile-information-data-row">
        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('name', { ns: NS_COMMON })}:`}</div>
          <div aria-label="guardian-name-value" className="patient-profile-information-label-field">{`${firstName ||
            '-'} ${lastName || '-'}`}</div>
        </div>
      </div>

      <div className="patient-profile-information-data-row">
        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('dateOfBirth', { ns: NS_COMMON })}:`}</div>
          <div className="patient-profile-information-label-field">{`${(moment.isMoment(dob) &&
            dob.format('DD/MMM/YYYY')) ||
            '-'}`}</div>
        </div>
      </div>

      <div className="patient-profile-information-data-row">
        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('phone', { ns: NS_COMMON })}:`}</div>
          <div className="patient-profile-information-label-field">
            {phone ? formatPhoneNumber(phone, phoneCode) : '-'}
          </div>
        </div>

        <div className="patient-profile-information-label">
          <div className="patient-profile-information-label-field">{`${t('email', { ns: NS_COMMON })}:`}</div>
          <div aria-label="guardian-email-value" className="patient-profile-information-label-field">
            {email || '-'}
          </div>
        </div>
      </div>
    </div>
  );
}
